import React, { useState, useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { getRawData } from "./../../Utils/actions/yh";
import { MaterialReactTable } from "material-react-table";
import { useTranslation } from "react-i18next";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import FormControl from "@mui/material/FormControl";
import { Select, MenuItem } from "@mui/material";

const useStyle = makeStyles((theme) => ({
  modalBody: {
    height: "70vh",
    // overflowY: "auto",
  },
  searchField: {
    flex: 1,
    marginRight: theme.spacing(1),
  },
  profileDiv: {
    border: "1px solid #ccc",
    borderRadius: "5px",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(1),
  },
  chipDiv: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  profileHeader: {
    display: "flex",
  },
  profileHeading: {
    flex: 1,
    display: "flex",
    alignContent: "center",
    fontWeight: "bold",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    flex: 1,
  },
}));

const DataViewer = ({
  deviceType,
  show,
  handleClose,
  rig,
  well,
  log,
  channel,
  DVdate,
  dataProvider,
}) => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { aspectRawData, aspectRawTotalRecord } = useSelector(
    (state) => state.yh
  );
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(
    sessionStorage.getItem("dataViewerPageSize")
      ? sessionStorage.getItem("dataViewerPageSize")
      : 10
  );

  useEffect(() => {
    if (DVdate) {
      dispatch(
        getRawData(
          rig,
          well,
          dataProvider,
          log,
          channel,
          DVdate?.original?.startPoint,
          DVdate?.original?.endPoint,
          pageSize,
          pageIndex
        )
      );
    }
  }, [
    rig,
    well,
    dataProvider,
    log,
    channel,
    DVdate?.original?.startPoint,
    DVdate?.original?.endPoint,
    pageSize,
    pageIndex,
  ]);
  sessionStorage.setItem("dataViewerPageSize", pageSize);

  const roleColumns = useMemo(
    () => [
      {
        accessorKey: "key",
        header: "key",
        enableEditing: false,
        enableResizing: true,
        size: 20,
      },
      {
        accessorKey: "value",
        header: "Value",
        enableResizing: true,
        size: 20,
      },
    ],
    [t]
  );

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };
  const handleStartChange = () => {
    setPageIndex(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(aspectRawTotalRecord / pageSize);
    setPageIndex(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName="modal-70w"
      backdrop="static"
      centered
      className="modelWidth"
    >
      <style>
        {`
            .modelWidth .modal-content {
               
            
                height: 35rem;
            } 
            .modelWidth .MuiPaper-root > .MuiBox-root:first-child{
                min-height: 25px;
            }    
        `}
      </style>
      <Modal.Header
        closeButton
        style={{
          backgroundColor: "#333333",
          color: "#c7c7c7",
        }}
      >
        <style>
          {`
            .modal-header .close {
                color: #c7c7c7;
                
            }     
        `}
        </style>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flex: 1,
          }}
        >
          <Modal.Title>Data Viewer</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body
        className={classes.modalBody}
        style={{ backgroundColor: "#242424", color: "#c7c7c7" }}
      >
        {deviceType === "TIMESERIES" ? (
          <span style={{ fontSize: "14px" }}>
            <b>Start Time:</b> {DVdate?.original?.startPoint} GMT+00:00{" "}
            <b>End Time:</b> {DVdate?.original?.endPoint} GMT+00:00
          </span>
        ) : (
          <span style={{ fontSize: "14px" }}>
            <b>Start Depth:</b> {DVdate?.original?.startPoint} <b>End Depth:</b>{" "}
            {DVdate?.original?.endPoint}
          </span>
        )}

        <span style={{ fontSize: "14px" }}>
          <b> Device Type:</b>{" "}
          {deviceType === "TIMESERIES" ? "Timeseries Log" : "Depthseries Log"}
        </span>

        <div className="m-0  overflow-auto border-0">
          {aspectRawData?.data !== "" ? (
            <MaterialReactTable
              muiTabEditIconleHeadCellProps={{
                sx: {
                  backgroundColor: "#242424",
                  color: "#fff",
                },
              }}
              muiTableProps={{
                sx: {
                  border: "none",
                },
                width: "100%",
              }}
              muiTablePaperProps={{
                sx: {
                  boxShadow: "none",
                  // height: "100vh",
                  height: "385px",
                  width: "100%",
                  position: "static",
                  display: "block",
                  overflow: "hidden",
                  // overflowY: "auto",
                  // overflowX: "auto",
                  backgroundColor: "#242424", // dark table background
                  scrollbarWidth: "thin",
                  "&::-webkit-scrollbar": {
                    width: "12px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#444",
                    borderRadius: "6px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#23272f",
                  },
                },
              }}
              muiTableContainerProps={{
                sx: {
                  height: "calc(100% - 50px)",
                  maxHeight: "none",
                  boxShadow: "none !important",
                  backgroundColor: "#181818",
                  // overflowY: "auto",
                  // overflowX: "auto",
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  backgroundColor: "#2e2e2e",
                  boxShadow: "none !important",

                  color: "#fff",
                },
              }}
              muiTableBodyRowProps={({ row, index }) => ({
                // sx: {
                //   cursor: "pointer",
                //   backgroundColor: row.getIsSelected()
                //     ? "bold"
                //     : index % 2 === 0
                //     ? "#cfd5e959"
                //     : "white",
                // },
                sx: {
                  cursor: "pointer",
                  boxShadow: "none !important",

                  backgroundColor: row.getIsSelected()
                    ? "#1c1c1c"
                    : // : index % 2 === 0
                      //   ? "#2e2e2e"
                      "#121212",
                },
              })}
              muiTableBodyProps={{
                sx: {
                  "& tr:nth-of-type(odd)": {
                    backgroundColor: "#cfd5e959",
                  },
                  "& td": {
                    padding: "0.5rem",
                    borderBottom: "1px solid #ccc",
                  },
                },
              }}
              columns={roleColumns}
              data={aspectRawData?.data || []}
              enableRowActions={false}
              enableEditing={false}
              enableStickyHeader={true}
              enableStickyFooter={false}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              positionActionsColumn="last"
              editDisplayMode="row"
              enableFilters={false}
              enableHiding={false}
              enablePagination={false}
              paginationDisplayMode="pages"
              enableTopToolbar={false}
              renderBottomToolbarCustomActions={({ table }) => (
                <>
                  <div style={{ marginLeft: "auto", color: "#c7c7c7" }}>
                    <span>Rows per Page </span>&nbsp;
                    <FormControl variant="standard" size="small">
                      <Select
                        value={pageSize}
                        onChange={(e) =>
                          handlePageSizeChange(Number(e.target.value))
                        }
                        sx={{
                          color: "#c7c7c7",
                          ".MuiSelect-icon": { color: "#c7c7c7" },
                          ".MuiOutlinedInput-notchedOutline": {
                            borderColor: "#444",
                          },
                        }}
                      >
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                    &nbsp;
                    <span>
                      {pageIndex * pageSize + 1}-
                      {Math.min(
                        pageIndex * pageSize + pageSize,
                        aspectRawTotalRecord
                      )}{" "}
                      of &nbsp;
                      {aspectRawTotalRecord}&nbsp;
                    </span>
                    <FirstPageIcon
                      onClick={() => {
                        if (pageIndex !== 0) {
                          handleStartChange();
                        }
                      }}
                      style={{
                        cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                        color:
                          pageIndex === 0
                            ? "rgba(255,255,255,0.26)"
                            : "#c7c7c7",
                      }}
                    />
                    <NavigateBeforeIcon
                      onClick={() => {
                        if (pageIndex !== 0) {
                          handlePageChange(pageIndex - 1);
                        }
                      }}
                      style={{
                        cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                        color:
                          pageIndex === 0
                            ? "rgba(255,255,255,0.26)"
                            : "#c7c7c7",
                      }}
                    />
                    <NavigateNextIcon
                      onClick={() => {
                        if ((pageIndex + 1) * pageSize < aspectRawTotalRecord) {
                          handlePageChange(pageIndex + 1);
                        }
                      }}
                      style={{
                        cursor:
                          (pageIndex + 1) * pageSize >= aspectRawTotalRecord
                            ? "not-allowed"
                            : "pointer",
                        color:
                          (pageIndex + 1) * pageSize >= aspectRawTotalRecord
                            ? "rgba(255,255,255,0.26)"
                            : "#c7c7c7",
                      }}
                    />
                    <LastPageIcon
                      onClick={() => {
                        if ((pageIndex + 1) * pageSize < aspectRawTotalRecord) {
                          handleEndChange();
                        }
                      }}
                      style={{
                        cursor:
                          (pageIndex + 1) * pageSize >= aspectRawTotalRecord
                            ? "not-allowed"
                            : "pointer",
                        color:
                          (pageIndex + 1) * pageSize >= aspectRawTotalRecord
                            ? "rgba(255,255,255,0.26)"
                            : "#c7c7c7",
                      }}
                    />
                  </div>
                </>
              )}
            />
          ) : (
            " "
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DataViewer;
